import '@descope-ui/descope-list-item';

import { componentName, ListClass } from './ListClass';

customElements.define(componentName, ListClass);

export { ListClass, componentName };
